/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOrgRequest } from '../models/CreateOrgRequest';
import type { CreateOrgResponse } from '../models/CreateOrgResponse';
import type { GetGmailOAuthTokenResult } from '../models/GetGmailOAuthTokenResult';
import type { GetGoogleAuthTokenRequest } from '../models/GetGoogleAuthTokenRequest';
import type { ListFilesAndDirectoriesResponse } from '../models/ListFilesAndDirectoriesResponse';
import type { Organization } from '../models/Organization';
import type { OrganizationInviteRequest } from '../models/OrganizationInviteRequest';
import type { OrgInvite } from '../models/OrgInvite';
import type { OrgInviteDeleteRequest } from '../models/OrgInviteDeleteRequest';
import type { OrgInviteDeleteResult } from '../models/OrgInviteDeleteResult';
import type { OrgInviteResult } from '../models/OrgInviteResult';
import type { OrgMember } from '../models/OrgMember';
import type { OrgMemberDeleteRequest } from '../models/OrgMemberDeleteRequest';
import type { OrgMemberDeleteResult } from '../models/OrgMemberDeleteResult';
import type { OrgMemberRoleUpdateRequest } from '../models/OrgMemberRoleUpdateRequest';
import type { OrgMemberRoleUpdateResult } from '../models/OrgMemberRoleUpdateResult';
import type { OrgPhoneNumber } from '../models/OrgPhoneNumber';
import type { OrgStripeProduct } from '../models/OrgStripeProduct';
import type { SyncSanaamRequest } from '../models/SyncSanaamRequest';
import type { SyncSanaamResponse } from '../models/SyncSanaamResponse';
import type { SyncStripeProductsRequest } from '../models/SyncStripeProductsRequest';
import type { SyncStripeProductsResponse } from '../models/SyncStripeProductsResponse';
import type { UpdateOrgRequest } from '../models/UpdateOrgRequest';
import type { UpdateOrgResponse } from '../models/UpdateOrgResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OrganizationService {

    /**
     * Add an invite for a user to the workspace.  If the user already has a profile,
     * the profile is immediately added to the workspace.  Otherwise, an invite is
     * created.
     * @param organizationId The ID of the org.
     * @param requestBody The request that includes the configuration of the invite.
     * @returns OrgInviteResult OK
     * @throws ApiError
     */
    public static addMember(
        organizationId: string,
        requestBody: OrganizationInviteRequest,
    ): CancelablePromise<OrgInviteResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/{organizationId}/members/add',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Creates a new organization.
     * @param requestBody The request to create an organization.
     * @returns CreateOrgResponse OK
     * @throws ApiError
     */
    public static createOrganization(
        requestBody?: CreateOrgRequest,
    ): CancelablePromise<CreateOrgResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Deletes a member from an organization. This will remove the profile from the org.
     * Only Admins or Owner can delete.
     * @param organizationId The ID of the org.
     * @param requestBody The request
     * @returns OrgInviteDeleteResult OK
     * @throws ApiError
     */
    public static deleteInvite(
        organizationId: string,
        requestBody: OrgInviteDeleteRequest,
    ): CancelablePromise<OrgInviteDeleteResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/{organizationId}/invites/delete',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Deletes a member from an organization. This will remove the profile from the org.
     * Only Admins or Owner can delete.
     * @param organizationId The ID of the org.
     * @param requestBody The request
     * @returns OrgMemberDeleteResult OK
     * @throws ApiError
     */
    public static deleteMember(
        organizationId: string,
        requestBody: OrgMemberDeleteRequest,
    ): CancelablePromise<OrgMemberDeleteResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/{organizationId}/members/delete',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param organizationId
     * @param requestBody
     * @returns GetGmailOAuthTokenResult OK
     * @throws ApiError
     */
    public static getGmailOAuthToken(
        organizationId: string,
        requestBody?: GetGoogleAuthTokenRequest,
    ): CancelablePromise<GetGmailOAuthTokenResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/{organizationId}/getGmailOAuthToken',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Retrieves the invites for a given org.
     * @param organizationId The ID of the org.
     * @returns OrgInvite OK
     * @throws ApiError
     */
    public static getInvites(
        organizationId: string,
    ): CancelablePromise<Array<OrgInvite>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/{organizationId}/invites',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieves the members and the invites for a given org.
     * @param organizationId The ID of the org.
     * @returns OrgMember OK
     * @throws ApiError
     */
    public static getMembers(
        organizationId: string,
    ): CancelablePromise<Array<OrgMember>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/{organizationId}/members',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieve all phone numbers that belongs to an organization
     * @param organizationId The organization Id
     * @returns OrgPhoneNumber OK
     * @throws ApiError
     */
    public static getOrganizationPhoneNumbers(
        organizationId: string,
    ): CancelablePromise<Array<OrgPhoneNumber>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/{organizationId}/phoneNumbers',
            path: {
                'organizationId': organizationId,
            },
        });
    }

    /**
     * Retrieves the invites for a given org.
     * @param organizationId The ID of the org.
     * @returns OrgStripeProduct OK
     * @throws ApiError
     */
    public static getStripeProducts(
        organizationId: string,
    ): CancelablePromise<Array<OrgStripeProduct>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/{organizationId}/stripeProducts',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieve all the files and directories based on search path per organization
     * @param organizationId The organization id
     * @param basePath The base path
     * @param searchPath The search path
     * @returns ListFilesAndDirectoriesResponse OK
     * @throws ApiError
     */
    public static listFilesAndDirectories(
        organizationId: string,
        basePath?: string,
        searchPath?: string,
    ): CancelablePromise<ListFilesAndDirectoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/{organizationId}/filesAndDirs',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'basePath': basePath,
                'searchPath': searchPath,
            },
        });
    }

    /**
     * @param organizationId
     * @returns string OK
     * @throws ApiError
     */
    public static orgLogoSignedUrl(
        organizationId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/{organizationId}/logo-signed-url',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieves the invites for a given org.
     * @param requestBody The request containing the organization ID.
     * @returns SyncSanaamResponse OK
     * @throws ApiError
     */
    public static syncSanaam(
        requestBody?: SyncSanaamRequest,
    ): CancelablePromise<SyncSanaamResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/syncSanaam',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieves the invites for a given org.
     * @param requestBody The request containing the organization ID.
     * @returns SyncStripeProductsResponse OK
     * @throws ApiError
     */
    public static syncStripeProducts(
        requestBody?: SyncStripeProductsRequest,
    ): CancelablePromise<SyncStripeProductsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/syncStripeProducts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Updates the role of a member in an organization.
     * Only Admins or Owner can update.
     * @param organizationId The ID of the org.
     * @param requestBody The request
     * @returns OrgMemberRoleUpdateResult OK
     * @throws ApiError
     */
    public static updateMemberRole(
        organizationId: string,
        requestBody: OrgMemberRoleUpdateRequest,
    ): CancelablePromise<OrgMemberRoleUpdateResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/{organizationId}/members/updaterole',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Updates an existing organization's details.
     * @param id The ID of the organization to update.
     * @param requestBody The request to update the organization.
     * @returns UpdateOrgResponse OK
     * @throws ApiError
     */
    public static updateOrganization(
        id: string,
        requestBody?: UpdateOrgRequest,
    ): CancelablePromise<UpdateOrgResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizations/update/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all active organizations that the user belongs to either as a creator or as a member.
     * @returns Organization OK
     * @throws ApiError
     */
    public static getOrganizations(): CancelablePromise<Array<Organization>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations',
        });
    }

    /**
     * Archive (hide) an organization.
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static hideOrganization(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/{id}/hide',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Unarchive (unhide) an organization.
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static unhideOrganization(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/{id}/unhide',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all archived organizations that the user belongs to.
     * @returns Organization OK
     * @throws ApiError
     */
    public static getArchivedOrganizations(): CancelablePromise<Array<Organization>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/archived',
        });
    }

}
